import type { ProjectIdCheckCommand, ProjectIdCheckResponse } from '../entity/ProjectTypes';
import type { ProjectRepository } from '../repository/ProjectRepository';

export class CheckProjectIdUseCase {
  constructor(private readonly repository: ProjectRepository) {}

  async execute(command: ProjectIdCheckCommand): Promise<ProjectIdCheckResponse> {
    return this.repository.checkProjectId(command);
  }
}

